<template>
	<div class="container">
		<div class="course">
			<div class="course-body">
				公司历程
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'CompanyCourse'
	}
</script>

<style scoped="scoped">
	@import url("./company-course.css");
</style>



// WEBPACK FOOTER //
// src/pages/company-course/company-course.vue